import React from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import { PROJECTS } from './queries';

const columns = [
  {
    key: 'id',
    label: 'ID',
  },
  {
    key: 'name',
    label: 'User name',
  },
  {
    key: 'title',
    label: 'Title',
  },
  {
    key: 'domains',
    label: 'Domains',
    value: ({ value }) => value.map(domain => domain.name).join(', ')
  },
];

const Projects = () => {
  const { data } = useQuery(PROJECTS);

  return (
    <View>
      {data && (
        <DataTable.Simple
          data={data.projects}
          columns={columns}
          pageLength="All"
          htmlTable
        />
      )}
    </View>
  );
};

export default Projects;
